/**
 * What the app hands the gallery so its sections draw with the app's own images. My Orders' channel logos, tag
 * icons and action glyphs are app assets (web sprites and CDN URLs, mobile PNGs and SVGs), injected through
 * `OrdersAssetsProvider` where the screen mounts; the gallery opens from the rollout panel, outside that provider.
 *
 * Each app registers a LOADER at start (`bootstrapCoreBridges.ts`), never the assets themselves: the assets file
 * pulls in the app's date picker and bill renderer, which only the gallery or My Orders should load. Without a
 * registration (tests, a shell that has not wired it) the sections draw every word and no image.
 */
import type { OrdersAssets } from "@rista/ui/components/MyOrders/assets";

type Loader<T> = () => Promise<T>;

let loadOrdersAssets: Loader<OrdersAssets> | null = null;

/** Called once by each app at start: how to load its My Orders assets when the gallery opens. */
export function registerGalleryOrdersAssets(loader: Loader<OrdersAssets>) {
  loadOrdersAssets = loader;
}

/** The registered My Orders assets, loaded on first ask; null when no app registered any. */
export async function galleryOrdersAssets(): Promise<OrdersAssets | null> {
  return loadOrdersAssets ? loadOrdersAssets() : null;
}
